import { SPRS_SET } from '../actionConstants';
import { Spr } from './sprsTypes';
import { Action } from '../../generalTypes';

/**
 * Set spr action
 *
 * @param sprs
 */
export const setSprs = (sprs: Spr): Action<Spr> => ({
  type: SPRS_SET,
  payload: sprs,
});
